// extracted by mini-css-extract-plugin
export default {"content":"NewAgentTaskForm-module__content--PzyH0","header":"NewAgentTaskForm-module__header--jynY_","skeleton":"NewAgentTaskForm-module__skeleton--tKbf2"};